export interface DeleteBudgetRequest {
  year: string
  branchCode: string
  departmentCode: string
  item: string
  equipType: string
}

export function DeleteBudgetRequestToJSON(value: DeleteBudgetRequest): any {
  return {
    year: value.year !== '' ? value.year : undefined,
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    department_code:
      value.departmentCode !== '' ? value.departmentCode : undefined,
    item: value.item !== '' ? value.item : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined
  }
}
